export default import.meta.ROLLUP_FILE_URL_C1$0R3_2;